import { escapeReferenceToken } from '@criteria/json-pointer'
import { OpenAPI as OpenAPIV3_0, Operation as OperationV3_0 } from '@criteria/openapi/v3.0'
import { OpenAPI as OpenAPIV3_1, Operation as OperationV3_1 } from '@criteria/openapi/v3.1'
import { operationsFromAPI } from 'criteria-docs-ui'
import { Select } from '@criteria-labs/react'

type OpenAPI = OpenAPIV3_1<never> | OpenAPIV3_0<never>
type Operation = OperationV3_1<never> | OperationV3_0<never>

export function APIExplorerOperationPicker({
  openAPI,
  value,
  onChange
}: {
  openAPI: OpenAPI
  value: (Operation & { path: `/${string}`; method: string; operationRef: string }) | null
  onChange?: (operation: Operation & { path: `/${string}`; method: string; operationRef: string }) => void
}) {
  // const tagNames = openAPI ? openAPI.tags?.map((tag) => tag.name) ?? [] : []

  const allOperations = openAPI ? operationsFromAPI(openAPI) : []
  const allOperationsByRef: Record<string, Operation & { path: `/${string}`; method: string; operationRef: string }> =
    {}
  allOperations.forEach(([path, _, method, operation]) => {
    const operationRef = `#/paths/${escapeReferenceToken(path)}/${method}`
    allOperationsByRef[operationRef] = { ...operation, path, method, operationRef }
  })

  return (
    <Select
      value={value?.operationRef ?? ''}
      onChange={onChange ? (e) => onChange(allOperationsByRef[e.target.value]) : undefined}
    >
      <option value="" disabled>
        Choose an operation&hellip;
      </option>
      {Object.values(allOperationsByRef).map((operation) => (
        <option key={operation.operationRef} value={operation.operationRef}>
          {operation.summary}
          {!operation.summary && (
            <>
              {operation.method.toUpperCase()} {operation.path}
            </>
          )}
        </option>
      ))}
    </Select>
  )
}
